import { withRouter } from 'src/helpers';
import { BookAppointment } from 'components/appointments/Book';

// The shared Book flow uses the front config by default
export default withRouter(BookAppointment);
